/**
 * Was an einer Eingangsrechnung in Prüfung eilt: Skonto läuft ab, Fälligkeit naht, oder sie liegt
 * schon lange (zeitnahe Erfassung nach GoBD). Ersetzt eine Benachrichtigung: sichtbar in der Liste.
 */

export type IncomingReviewAttention = {
  kind: 'skonto' | 'due' | 'overdue' | 'stale';
  label: string;
};

/** So viele Tage vorher gilt eine Frist als dringend. */
export const REVIEW_ATTENTION_HORIZON_DAYS = 3;

function addDays(iso: string, days: number): string {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

function dayMonth(iso: string): string {
  return `${iso.slice(8, 10)}.${iso.slice(5, 7)}.`;
}

function daysBetween(fromIso: string, toIso: string): number {
  return Math.round((Date.parse(`${toIso}T12:00:00Z`) - Date.parse(`${fromIso}T12:00:00Z`)) / 86_400_000);
}

export function incomingReviewAttention(
  row: {
    status: string;
    approved_at?: string | null;
    source?: string | null;
    skonto_amount?: number | string | null;
    skonto_due_date?: string | null;
    due_date?: string | null;
    created_at?: string | null;
  },
  params: { today: string; staleDays: number },
): IncomingReviewAttention | null {
  if (row.status !== 'draft' || row.approved_at || row.source === 'sage_import') return null;
  const horizon = addDays(params.today, REVIEW_ATTENTION_HORIZON_DAYS);

  const skonto = String(row.skonto_due_date ?? '').slice(0, 10);
  if (skonto && Number(row.skonto_amount ?? 0) > 0 && skonto >= params.today && skonto <= horizon) {
    return { kind: 'skonto', label: `Skonto bis ${dayMonth(skonto)}` };
  }
  const due = String(row.due_date ?? '').slice(0, 10);
  if (due && due < params.today) return { kind: 'overdue', label: `fällig seit ${dayMonth(due)}` };
  if (due && due <= horizon) return { kind: 'due', label: `fällig ${dayMonth(due)}` };

  const created = String(row.created_at ?? '').slice(0, 10);
  if (created) {
    const age = daysBetween(created, params.today);
    if (age > Math.max(1, params.staleDays)) return { kind: 'stale', label: `seit ${age} Tagen in Prüfung` };
  }
  return null;
}
